import React, { useState, useEffect } from "react";
import { Switch, Checkbox, Row, Col, Collapse, Form, Input } from "antd";
// style
import styles from "./form.module.css";

const { Panel } = Collapse;

const MyDocsForm = ({
  isAdmin,
  disabledState,
  idRequired = false,
  getFieldValue,
}) => {
  const [, setSolutionAccess] = useState(
    getFieldValue("my_docs_solution_access"),
  );
  useEffect(() => {
    setSolutionAccess(getFieldValue("my_docs_solution_access"));
  }, [getFieldValue("my_docs_solution_access")]);

  const solutionAccessOnChange = () => {
    setSolutionAccess((prevState) => !prevState);
  };

  return (
    <Collapse defaultActiveKey={["2_1"]} expandIconPosition="end">
      <Panel header="myDocs" key="2_1">
        <div className="is_form_2_a">
          {idRequired && (
            <Form.Item
              name="_id"
              rules={[
                {
                  required: true,
                  message: "Please input the id!",
                },
              ]}
              style={{ display: "none" }}
            >
              <Input />
            </Form.Item>
          )}

          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Solution Access</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  noStyle
                  name="my_docs_solution_access"
                  valuePropName="checked"
                  style={{
                    borderBottom: "none",
                  }}
                >
                  <Switch
                    disabled={disabledState}
                    onChange={solutionAccessOnChange}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Documents</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={4} lg={4} sm={6}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                        margin: "0px",
                      }}
                      name="my_docs_documents_view"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        View
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  <Col xxl={2} xl={4} lg={4} sm={6}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_documents_print"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        Print
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xxl={2} xl={4} lg={4} sm={6}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_documents_share"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        Share
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xxl={3} xl={4} lg={4} sm={6}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_documents_delete"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        Delete
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xxl={3} xl={4} lg={4} sm={8}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_documents_upload"
                      valuePropName="checked"
                    >
                      <Checkbox disabled>Check in</Checkbox>
                    </Form.Item>
                  </Col>

                  <Col xxl={3} xl={4} lg={4} sm={8}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_documents_download"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        Download
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  <Col xxl={3} xl={8} lg={8} sm={12}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_documents_modify"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        Modify/Re-Index
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xxl={3} xl={6} lg={8} sm={12}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_documents_add"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        Add/Upload
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Annotation</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={3} xl={4} lg={4} sm={8}>
                    <Form.Item
                      noStyle
                      name="my_docs_annotation_view"
                      valuePropName="checked"
                    >
                      <Checkbox disabled>View</Checkbox>
                    </Form.Item>
                  </Col>

                  <Col xxl={3} xl={4} lg={4} sm={8}>
                    <Form.Item
                      noStyle
                      name="my_docs_annotation_add"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        Add
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xxl={3} xl={4} lg={4} sm={8}>
                    <Form.Item
                      noStyle
                      name="my_docs_signature_sign"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        Fill and Sign
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          {isAdmin && (
            <>
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>Retention</label>
                  </Col>

                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={4} xl={8} lg={8} sm={12}>
                        <Form.Item
                          noStyle
                          name="my_docs_retention_set"
                          valuePropName="checked"
                        >
                          <Checkbox disabled>Set Retention</Checkbox>
                        </Form.Item>
                      </Col>

                      <Col xxl={4} xl={8} lg={8} sm={12}>
                        <Form.Item
                          noStyle
                          name="my_docs_retention_remove"
                          valuePropName="checked"
                        >
                          <Checkbox disabled>Remove Retention</Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>

              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>Destruction</label>
                  </Col>

                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={4} xl={8} lg={8} sm={12}>
                        <Form.Item
                          noStyle
                          name="my_docs_destruction_set"
                          valuePropName="checked"
                        >
                          <Checkbox disabled>Set Destruction</Checkbox>
                        </Form.Item>
                      </Col>

                      <Col xxl={4} xl={6} lg={8} sm={12}>
                        <Form.Item
                          noStyle
                          name="my_docs_destruction_remove"
                          valuePropName="checked"
                        >
                          <Checkbox disabled>Remove Destruction</Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>Approve</label>
                  </Col>

                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={4} xl={6} lg={8} sm={12}>
                        <Form.Item
                          style={{
                            borderBottom: "none",
                          }}
                          name="my_docs_approve_destruction_lists"
                          valuePropName="checked"
                        >
                          <Checkbox disabled>Destruction</Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </>
          )}

          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Recycle Bin</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={3} xl={4} lg={4} sm={8}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_recycle_bin_view"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        View
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  <Col xxl={3} xl={4} lg={4} sm={8}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_recycle_bin_empty"
                      valuePropName="checked"
                    >
                      <Checkbox disabled>Empty</Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xxl={3} xl={4} lg={4} sm={8}>
                    <Form.Item
                      noStyle
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_recycle_bin_restore"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        Restore
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Full Text Search</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_full_text"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Flat File</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={6} sm={6}>
                    <Form.Item
                      noStyle
                      name="my_docs_flat_file_view"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      >
                        View
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Custom Inputs Allowed</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_is_custom_inputs_allowed"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Delete Signed/Reviewed Reports </label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="my_docs_delete_signed_reviewed_reports"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("my_docs_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </Panel>
    </Collapse>
  );
};

export default MyDocsForm;
